module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "cpy_info"
  }, [_c('el-card', {
    staticClass: "box-card"
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('center', [_c('h4', [_vm._v(_vm._s(_vm.contentData.title))]), _vm._v(" "), _c('h6', [_vm._v("发布时间：" + _vm._s(_vm.contentData.publishTime))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "text item",
    domProps: {
      "innerHTML": _vm._s(_vm.contentData.content)
    }
  })])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7fc904b8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/purchaseContent.vue
// module id = 247
// module chunks = 2